import { useDetails } from '@/src/hooks/useDetails';
import { useTokensStoreForFunds } from '@/src/hooks/useTokensStoreForFunds';
import { useWalletPkh } from '@/src/hooks/useWalletPkh';
import { FundWithDetailsEntity, ProtocolEntity } from '@/src/lib/MayzSmartDB/Entities/index';
import { FundWithDetailsApi } from '@/src/lib/MayzSmartDB/FrontEnd/index';
import { isNullOrBlank } from '@/src/lib/MayzSmartDB';
import { FUND_STATUS_CLOSED, FUND_STATUS_READY } from '@/src/utils/constants';
import { useEffect, useState } from 'react';
import { useAppStore, useWalletStore } from '../store';
import { useSession } from 'next-auth/react';

export interface IFundDetailsForUsers {
    id?: string;
    isTokensStoreReady: boolean;
    isRefreshing: boolean;
    isLoadingDetails: boolean;
    isLoadedDetails: boolean;
    protocol: ProtocolEntity | undefined;
    fund: FundWithDetailsEntity | undefined;
    isAdminOrCreator: boolean;
    refreshDetails: (new_id?: string) => Promise<void>;
    // handleBtnDelegate: (fund: FundWithDetailsEntity) => Promise<void>;
    // handleBtnDelegationManage: (fund: FundWithDetailsEntity) => Promise<void>;
    // handleBtnJoinAda: (fund: FundWithDetailsEntity) => Promise<void>;
    // handleBtnJoinTokens: (fund: FundWithDetailsEntity) => Promise<void>;
    // handleBtnDepositWithdrawPage: (fund: FundWithDetailsEntity) => Promise<void>;
}

interface useFundDetailsForUsersProps {
    id?: string;
}

export default function useFundDetailsForHome(props: useFundDetailsForUsersProps): IFundDetailsForUsers {
    //--------------------------------------
    let { id } = props;
    //--------------------------------------
    const [isRefreshing, setIsRefreshing] = useState(true);
    useEffect(() => {
        setIsRefreshing(false);
    }, []);
    //--------------------------------------
    const { userPkh } = useWalletPkh();
    const appStore = useAppStore();
    //--------------------------------------
    const { data: session, status } = useSession();
    const walletStore = useWalletStore();
    //--------------------------------------
    const loadDetails = async (new_id?: string) => {
        //----------
        // console.log(`useFundDetailsForHome - appStore.protocol: ${appStore.protocol}`);
        //----------
        let fund: FundWithDetailsEntity | undefined = undefined;
        //----------
        if (isNullOrBlank(new_id) === false) {
            id = new_id;
        }
        //----------
        if (isNullOrBlank(id)) {
            // fund = await FundWithDetailsApi.getOneByParamsApi_({ $or: [{ status: FUND_STATUS_READY }, { status: FUND_STATUS_CLOSED }], _isDeployed: true, showInSite: true }, FundWithDetailsEntity.optionsGetForFundList_ForAdmin);
        } else {
            const isCoreTeam = walletStore.isCoreTeam(true, session, status);
            if (isCoreTeam) {
                fund = await FundWithDetailsApi.getOneByParamsApi_(
                    { _id: id, $or: [{ status: FUND_STATUS_READY }, { status: FUND_STATUS_CLOSED }], _isDeployed: true, showInSite: true },
                    FundWithDetailsEntity.optionsGetForFundList_ForPublic
                );
            } else {
                fund = await FundWithDetailsApi.getOneByParamsApi_(
                    { _id: id, $or: [{ status: FUND_STATUS_READY }, { status: FUND_STATUS_CLOSED }], _isDeployed: true, showInSite: true, showInHome: true },
                    FundWithDetailsEntity.optionsGetForFundList_ForPublic
                );
            }
        }
        //----------
        let protocol: ProtocolEntity | undefined = appStore.protocol!;
        //----------
        return { fund, protocol };
    };
    //--------------------------------------
    type Details = {
        fund: FundWithDetailsEntity | undefined;
        protocol: ProtocolEntity | undefined;
    };
    //--------------------------------------
    const { isLoadingDetails, isLoadedDetails, current, refreshDetails } = useDetails<Details>({
        nameDetails: FundWithDetailsEntity.className(),
        loadDetails,
        dependencies: [id, appStore.isProtocolLoaded],
        checkDependencies: () => {
            const result = id !== undefined && appStore.isProtocolLoaded === true;
            // console.log(`useFundDetailsForHome - checkDependencies: ${result}`);
            return result;
        },
    });
    //--------------------------------------
    const { isTokensStoreReady } = useTokensStoreForFunds({
        mode: 'FundDetails',
        name: 'FundDetailsForUsers',
        isLoadedDetails,
        fund: current?.fund,
        followUp: undefined,
        keepAlive: undefined,
        addTokenFT: true,
        addSubTokensFT: true,
        swAddPrice: true,
        swAddMetadata: true,
        initPriceUpdater: false,
    });
    //--------------------------------------
    // const handleBtnDelegate = async (fund: FundWithDetailsEntity) => {
    //     // await router.push({
    //     //     pathname: ROUTES.Delegate,
    //     //     query: { id: fund._DB_id },
    //     // });
    // };
    // const handleBtnDelegationManage = async (fund: FundWithDetailsEntity) => {
    //     // setIsRefreshing(true);
    //     // await router.push({
    //     //     pathname: '/user/portfolio',
    //     //     query: { task: TASK.DELEGATIONS, fund_id: fund._DB_id },
    //     // });
    // };
    // //--------------------------------------
    // const handleBtnJoinAda = async (fund: FundWithDetailsEntity) => {
    //     // setIsRefreshing(true);
    //     // await router.push({
    //     //     pathname: ROUTES.Join,
    //     //     query: { id: fund._DB_id },
    //     // });
    // };
    // //--------------------------------------
    // const handleBtnJoinTokens = async (fund: FundWithDetailsEntity) => {
    //     await router.push({
    //         pathname: ROUTES.UNDERCONSTRUCTION,
    //     });
    // };
    // //--------------------------------------
    // const handleBtnDepositWithdrawPage = async (fund: FundWithDetailsEntity) => {
    //     // setIsRefreshing(true);
    //     // await router.push({
    //     //     pathname: ROUTES.Deposit,
    //     //     query: { id: fund._DB_id },
    //     // });
    // };
    //--------------------------------------
    const [isAdminOrCreator, setIsAdminOrCreator] = useState(false);
    useEffect(() => {
        setIsAdminOrCreator((userPkh !== undefined && (current?.fund?.isAdmin(userPkh) || current?.fund?.isCreator(userPkh))) === true);
    }, [userPkh, current]);
    //--------------------------------------
    return {
        id,
        isTokensStoreReady,
        isRefreshing,
        isLoadingDetails,
        isLoadedDetails,
        protocol: current?.protocol,
        fund: current?.fund,
        isAdminOrCreator,
        refreshDetails,
        // handleBtnDelegate,
        // handleBtnJoinAda,
        // handleBtnJoinTokens,
        // handleBtnDepositWithdrawPage,
        // handleBtnDelegationManage,
    };
    //--------------------------------------
}
